<template>
  <div id="app"></div>
</template>
<script>
import pdfMake from "pdfmake";
import axios from "axios";
import moment from "moment";

export default {
  components: {},
  data() {
    return {};
  },
  methods: {
    loadReceipt: function() {
      var localApp = this;
      axios
        .get("/api/receipt/" + this.$route.params.id, {
          headers: {
            Authorization: "Bearer " + localStorage.token,
          },
        })
        .then(function(response) {
          localApp.export(response.data.data);
        })
        .catch(function() {
          localApp.kick();
        });
    },
    export(data) {
      // console.log(data);
      const docDefinition = {
        pageSize: {
          width: 200,
          height: "auto",
        },
        pageOrientation: "portrait",
        pageMargins: [10, 10, 10, 10],
        defaultStyle: {
          font: "Sarabun",
          fontSize: 11,
        },
        content: [
          {
            table: {
              widths: ["*"],
              body: [
                [
                  {
                    text: "ใบรับงาน/ใบรับเงิน",
                    border: [true, true, true, false],
                    margin: [0, 5, 0, 0],
                    style: "head",
                    bold: true,
                  },
                ],
                [
                  {
                    text: "039-381255, 065-9493287, 082-6716789",
                    style: "subhead",
                    margin: [0, -5, 0, 5],
                    border: [true, false, true, true],
                    bold: true,
                  },
                ],
              ],
            },
          },
          {
            table: {
              widths: [95, 85],
              body: [
                [
                  {
                    text:
                      "วันที่ " +
                      new Date(moment(data.created_at)).toLocaleDateString("th-TH", {
                        year: "numeric",
                        month: "long",
                        day: "numeric",
                        hour: "numeric",
                        minute: "numeric",
                        second: "numeric",
                      }),
                    border: [false, false, false, false],
                    margin: [0, 0, 0, 0],
                    style: "supersubhead",
                  },
                  {
                    text: "เลขที่ใบเสร็จ " + data.receipt,
                    border: [false, false, false, false],
                    margin: [0, 0, 0, 0],
                    style: "supersubhead",
                  },
                ],
                [
                  {
                    text: "",
                    border: [false, false, false, false],
                    margin: [0, -5, 0, 0],
                  },
                  {
                    text: "พนักงาน " + data.created_by_name,
                    border: [false, false, false, false],
                    margin: [0, -5, 0, 0],
                    style: "supersubhead",
                  },
                ],
              ],
            },
          },
          {
            canvas: [
              { type: "line", x1: 0, y1: 0, x2: 285, y2: 0, lineWidth: 1 },
            ],
            margin: [0, 10, 0, 10],
          },
          {
            table: {
              widths: [95, 85],
              body: [
                [
                  {
                    text: "ชื่อ " + data.name,
                    border: [false, false, false, false],
                    margin: [0, -5, 0, 5],
                    style: "supersubhead",
                  },
                  {
                    text: "เบอร์โทรศัพท์ " + data.tel,
                    border: [false, false, false, false],
                    margin: [0, -5, 0, 5],
                    style: "supersubhead",
                  },
                ],
              ],
            },
          },
          {
            table: {
              widths: [60, 120],
              body: [
                [
                  {
                    text:
                      data.license_plate +
                      "\n" +
                      (data.getprovince ? data.getprovince.name : ""),
                    margin: [10, 5, 10, 5],
                    style: "license",
                    bold: true,
                  },
                ],
              ],
            },
          },
          {
            text: "ประเภทรถ",
            bold: true,
            absolutePosition: {
              x: 85,
              y: 120,
            },
          },
          {
            text: "เอกสาร",
            bold: true,
            absolutePosition: {
              x: 85,
              y: 145,
            },
          },
          {
            text: "❐ มอไซค์",
            bold: true,
            absolutePosition: {
              x: 120,
              y: 120,
            },
          },
          {
            text: "❐ รถยนต์",
            bold: true,
            absolutePosition: {
              x: 158,
              y: 120,
            },
          },

          {
            text: "□ เล่ม",
            bold: true,
            absolutePosition: {
              x: 120,
              y: 147,
            },
          },
          {
            text: "□ สำเนา",
            bold: true,
            absolutePosition: {
              x: 158,
              y: 146,
            },
          },
          {
            text: data.cal_selected_type === 4 ? "√" : "",
            absolutePosition: {
              x: 122,
              y: 120,
            },
          },
          {
            text: data.cal_selected_type !== 4 ? "√" : "",
            absolutePosition: {
              x: 160,
              y: 119,
            },
          },
          {
            text:
              data.cal_document_type && data.cal_document_type === "1"
                ? "√"
                : "",
            absolutePosition: {
              x: 122,
              y: 146,
            },
          },
          {
            text:
              data.cal_document_type && data.cal_document_type !== "1"
                ? "√"
                : "",
            absolutePosition: {
              x: 160,
              y: 146,
            },
          },
          {
            canvas: [
              { type: "line", x1: 0, y1: 0, x2: 285, y2: 0, lineWidth: 1 },
            ],
            margin: [0, 10, 0, 10],
          },
          ...(data.cal_is_check_price_enable || data.cal_is_wsu_price_enable || data.cal_is_tax_price_enable || data.cal_is_tax_fine_price_enable || data.cal_is_service_enable || data.cal_is_other_enable ? [{
            table: {
              widths: [120, 40],
              body: [
                ...(data.cal_is_check_price_enable ? [[
                  {
                    text: "ตรวจสภาพรถ",
                    border: [false, false, false, false],
                    style: "name",
                  },
                  {
                    text: this.formatToPrice(data.cal_check_price),
                    border: [false, false, false, false],
                    style: "price",
                  },
                ]] : []),
                ...(data.cal_is_wsu_price_enable ? [[
                  {
                    text: "พ.ร.บ.",
                    border: [false, false, false, false],
                    style: "name",
                  },
                  {
                    text: this.formatToPrice(data.cal_wsu_price),
                    border: [false, false, false, false],
                    style: "price",
                  },
                ]] : []),
                ...(data.cal_is_tax_price_enable || data.cal_is_tax_fine_price_enable ? [[
                  {
                    text: "ภาษี + ค่าปรับ",
                    border: [false, false, false, false],
                    style: "name",
                  },
                  {
                    text: this.formatToPrice(
                      (data.cal_is_tax_price_enable ? parseFloat(data.cal_tax_price) : 0) +
                        (data.cal_is_tax_fine_price_enable ? parseFloat(data.cal_tax_fine_price) : 0)
                    ),
                    border: [false, false, false, false],
                    style: "price",
                  },
                ]] : []),
                ...(data.cal_is_service_enable ? [[
                  {
                    text: "ค่าบริการ",
                    border: [false, false, false, false],
                    style: "name",
                  },
                  {
                    text: this.formatToPrice(data.cal_service_price),
                    border: [false, false, false, false],
                    style: "price",
                  },
                ]] : []),
                ...(data.cal_is_other_enable ? [[
                  {
                    text: "อื่น ๆ",
                    border: [false, false, false, false],
                    style: "name",
                  },
                  {
                    text: this.formatToPrice(data.cal_other_price),
                    border: [false, false, false, false],
                    style: "price",
                  },
                ]] : []),
              ],
            },
          }] : []),
          {
            canvas: [
              { type: "line", x1: 0, y1: 0, x2: 285, y2: 0, lineWidth: 1 },
            ],
            margin: [0, 45, 0, 0],
          },
          {
            canvas: [
              { type: "line", x1: 0, y1: 0, x2: 285, y2: 0, lineWidth: 1 },
            ],
            margin: [0, 5, 0, 10],
          },
          {
            table: {
              widths: [120, 40],
              body: [
                [
                  {
                    text: "รวมทั้งหมด",
                    border: [false, false, false, false],
                    style: "name",
                    bold: true,
                  },
                  {
                    text: this.formatToPrice(
                      (data.cal_is_check_price_enable ? parseFloat(data.cal_check_price) : 0) +
                        (data.cal_is_wsu_price_enable ? parseFloat(data.cal_wsu_price) : 0) +
                        (data.cal_is_tax_price_enable ? parseFloat(data.cal_tax_price) : 0) +
                        (data.cal_is_tax_fine_price_enable ? parseFloat(data.cal_tax_fine_price) : 0) +
                        (data.cal_is_service_enable ? parseFloat(data.cal_service_price) : 0) +
                        (data.cal_is_other_enable ? parseFloat(data.cal_other_price) : 0)
                    ),
                    border: [false, false, false, false],
                    style: "price",
                    bold: true,
                  },
                ],
              ],
            },
          },
          {
            table: {
              widths: [150],
              body: [
                [
                  {
                    text: "นัดรับวันที่ ...............................",
                    style: "subhead",
                    margin: [10, 5, 5, 5],
                    bold: true,
                  },
                ],
              ],
            },
            absolutePosition: {
              x: 25,
              y: 280,
            },
          },
          {
            text: data.cal_appointment_date ? new Date(moment(data.cal_appointment_date)).toLocaleDateString(
              "th-TH",
              {
                year: "numeric",
                month: "long",
                day: "numeric",
              }
            ) : "",
            style: "supersubhead",
            margin: [0, 0, 0, 0],
            absolutePosition: {
              x: 103,
              y: 287,
            },
          },
        ],
        styles: {
          head: {
            alignment: "center",
            fontSize: 16,
          },
          subhead: {
            alignment: "center",
            fontSize: 12,
          },
          supersubhead: {
            alignment: "left",
            fontSize: 9,
          },
          license: {
            alignment: "center",
            fontSize: 12,
          },

          name: {
            alignment: "left",
            fontSize: 12,
          },
          price: {
            alignment: "right",
            fontSize: 12,
          },
        },
      };
      pdfMake.fonts = {
        Roboto: {
          normal:
            "https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Regular.ttf",
          bold:
            "https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Medium.ttf",
          italics:
            "https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Italic.ttf",
          bolditalics:
            "https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-MediumItalic.ttf",
        },
        Sarabun: {
          normal: window.location.origin + "/fonts/THSarabun.ttf",
          bold: window.location.origin + "/fonts/THSarabunBold.ttf",
          italics: window.location.origin + "/fonts/THSarabunItalic.ttf",
          bolditalics: window.location.origin + "/fonts/THSarabunBoldItalic.ttf",
        },
      };
      pdfMake.createPdf(docDefinition).open({}, window);
    },
    formatToPrice(value) {
      var num = parseFloat(value) || 0;
      return `${num.toLocaleString("th-TH", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })}`;
    },
  },
  mounted() {
    this.loadReceipt();
  },
};
</script>
<style></style>
